import type { ILink, LinkType } from '@platform/core/types';

/** Типи зв'язку в порядку прототипу v4 (LINK_TYPES): пов'язано · блокує · заблоковано · батьківський · дочірній · дублює · дубльовано · продовжує · продовжено. */
export const LINK_ORDER: readonly LinkType[] = ['relates', 'blocks', 'blocked', 'parent', 'child', 'duplicates', 'duplicated', 'follows', 'followed'];

const rank = (type: string): number => {
  const i = LINK_ORDER.indexOf(type as LinkType);
  return i < 0 ? LINK_ORDER.length : i;
};

/** Зв'язки, відсортовані за типом (порядок LINK_ORDER), усередині типу — як дав API. Чиста функція. */
export function sortLinks(links: readonly ILink[]): ILink[] {
  return links.map((l, i) => ({ l, i })).sort((a, b) => rank(a.l.linkType) - rank(b.l.linkType) || a.i - b.i).map((x) => x.l);
}

/** Підсумок за типами для чипів «■ Пов'язано з · 13» (лише наявні типи, у порядку LINK_ORDER). Чиста функція. */
export function linkTypeSummary(links: readonly ILink[]): Array<{ type: string; count: number }> {
  const counts = new Map<string, number>();
  for (const l of links) counts.set(l.linkType, (counts.get(l.linkType) ?? 0) + 1);
  return [...counts.entries()].sort(([a], [b]) => rank(a) - rank(b)).map(([type, count]) => ({ type, count }));
}
